(()=>{if(window.__mzPremiumHeaderV3)return;window.__mzPremiumHeaderV3=true;
const onReady=(fn)=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn,{once:true}):fn();
onReady(()=>{
  const header=document.querySelector('[data-mz-premium-header]');if(!header)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion=header.dataset.motionEnabled!=='false'&&!reduce;
  const gs=()=>window.gsap;
  const animateIn=(el,kind='panel')=>{
    if(!motion||!el)return;
    const g=gs();
    if(g){g.killTweensOf(el);g.fromTo(el,kind==='panel'?{opacity:0,y:-8,scaleY:.96}:{opacity:0,y:-8},{opacity:1,y:0,scaleY:1,duration:.34,ease:'power3.out',transformOrigin:'top center'});return;}
    el.animate(kind==='panel'?[{opacity:0,transform:'translateY(-8px) scaleY(.96)'},{opacity:1,transform:'none'}]:[{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'none'}],{duration:300,easing:'cubic-bezier(.2,.8,.2,1)'});
  };
  const animateOut=(el,done)=>{
    if(!motion||!el){done?.();return;}
    const g=gs();if(g){g.killTweensOf(el);g.to(el,{opacity:0,y:-6,duration:.2,ease:'power2.in',onComplete:done});return;}
    const a=el.animate([{opacity:1,transform:'none'},{opacity:0,transform:'translateY(-6px)'}],{duration:180,easing:'ease-in'});a.addEventListener('finish',()=>done?.(),{once:true});
  };

  if(motion){
    const targets=[header.querySelector('.mz-premium-brand'),header.querySelector('.mz-premium-nav'),header.querySelector('.mz-premium-search-wrap'),header.querySelector('.mz-premium-actions')].filter(Boolean);
    const g=gs();
    if(g)g.from(targets,{opacity:0,y:-12,duration:.65,stagger:.05,ease:'power3.out',clearProps:'transform'});
    else targets.forEach((el,i)=>el.animate([{opacity:0,transform:'translateY(-10px)'},{opacity:1,transform:'none'}],{duration:480,delay:i*45,easing:'cubic-bezier(.2,.8,.2,1)',fill:'both'}));
  }

  const compact=header.dataset.compactOnScroll!=='false';
  let ticking=false;
  let compactState=header.dataset.scrolled==='true';
  const COMPACT_ENTER_Y=180;
  const COMPACT_EXIT_Y=36;
  const syncScroll=()=>{
    ticking=false;
    const y=Math.max(0,window.scrollY||document.documentElement.scrollTop||0);
    if(!compact){
      compactState=false;
    }else if(!compactState && y>=COMPACT_ENTER_Y){
      compactState=true;
    }else if(compactState && y<=COMPACT_EXIT_Y){
      compactState=false;
    }
    const next=compactState?'true':'false';
    if(header.dataset.scrolled!==next) header.dataset.scrolled=next;
  };
  addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(syncScroll)}},{passive:true});
  addEventListener('pageshow',()=>requestAnimationFrame(syncScroll),{passive:true});
  syncScroll();

  const mzRefMagnetic = motion && matchMedia('(hover:hover) and (pointer:fine)').matches;
  if(mzRefMagnetic){
    header.querySelectorAll('.mz-premium-action,.mz-premium-nav__link').forEach((el)=>{
      el.addEventListener('pointermove',(event)=>{
        const g=gs(); if(!g)return;
        const rect=el.getBoundingClientRect();
        const x=(event.clientX-rect.left-rect.width/2)*.09;
        const y=(event.clientY-rect.top-rect.height/2)*.09;
        g.to(el,{x,y,duration:.22,ease:'power3.out',overwrite:true});
      });
      el.addEventListener('pointerleave',()=>{
        gs()?.to(el,{x:0,y:0,duration:.48,ease:'elastic.out(1,.46)',overwrite:true});
      });
    });
  }

  const mega=header.querySelector('[data-mz-mega-menu]');
  const megaToggle=header.querySelector('[data-mz-mega-toggle]');
  let megaOpen=false;
  const closeMega=(restore=false)=>{
    if(!megaOpen||!mega)return;megaOpen=false;megaToggle?.setAttribute('aria-expanded','false');
    animateOut(mega,()=>{mega.hidden=true;mega.style.removeProperty('opacity');mega.style.removeProperty('transform')});
    if(restore)megaToggle?.focus();
  };
  const openMega=()=>{
    if(!mega||innerWidth<1024)return;megaOpen=true;mega.hidden=false;megaToggle?.setAttribute('aria-expanded','true');closeSearch();animateIn(mega);
  };
  megaToggle?.addEventListener('click',()=>megaOpen?closeMega():openMega());

  const mobileSearch=header.querySelector('[data-mz-mobile-search-toggle]');
  const searchWrap=header.querySelector('[data-mz-search-wrap]');
  const form=header.querySelector('[data-mz-premium-search-form]');
  const input=header.querySelector('[data-mz-premium-search-input]');
  const panel=header.querySelector('[data-mz-search-panel]');
  const results=header.querySelector('[data-mz-search-results]');
  const status=header.querySelector('[data-mz-search-status]');
  const endpoint=(header.dataset.searchEndpoint||'/search/suggest').replace(/\.json$/,'');
  const searchUrl=header.dataset.searchUrl||'/search';
  const min=Math.max(1,Number(header.dataset.searchMin)||2);
  const limit=Math.min(10,Math.max(4,Number(header.dataset.searchLimit)||8));
  const predictive=header.dataset.searchEnabled!=='false';
  const currency=header.dataset.currency||'USD';
  let timer=0,controller=null,searchOpen=false;

  const price=(raw)=>{const n=Number(raw);if(!Number.isFinite(n))return '';try{return new Intl.NumberFormat(undefined,{style:'currency',currency}).format(n)}catch(_){return String(raw)}};
  const node=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e};
  const link=(href,cls,text)=>{const a=node('a',cls,text);a.href=href;return a};

  function closeSearch(){
    if(!panel||panel.hidden)return;searchOpen=false;input?.setAttribute('aria-expanded','false');
    animateOut(panel,()=>{panel.hidden=true;panel.style.removeProperty('opacity');panel.style.removeProperty('transform')});
  }
  function openSearch(){if(!panel)return;closeMega();panel.hidden=false;searchOpen=true;input?.setAttribute('aria-expanded','true');animateIn(panel);}
  function render(data,term){
    if(!results)return;
    results.replaceChildren();
    const root=data?.resources?.results||{};
    const products=Array.isArray(root.products)?root.products:[];
    const collections=Array.isArray(root.collections)?root.collections:[];
    const queries=Array.isArray(root.queries)?root.queries:[];
    if(!products.length&&!collections.length&&!queries.length){
      results.append(node('div','mz-ps-empty',`No matches yet for “${term}”`));
      openSearch();status&&(status.textContent='No suggestions found');return;
    }
    if(products.length){
      const sec=node('section','mz-ps-section');sec.append(node('div','mz-ps-title','Products'));
      const list=node('div','mz-ps-products');
      products.slice(0,limit).forEach(p=>{
        const a=link(p.url||searchUrl,'mz-ps-product');
        const img=document.createElement('img');const src=p.featured_image?.url||p.image||'';if(src){img.src=src;img.alt=p.featured_image?.alt||p.title||'';img.loading='lazy'}else img.alt='';
        const copy=node('span','mz-ps-product__copy');copy.append(node('strong','',p.title||'Product'));if(p.type)copy.append(node('small','',p.type));
        a.append(img,copy,node('span','mz-ps-price',price(p.price)));list.append(a);
      });
      sec.append(list);results.append(sec);
    }
    if(collections.length||queries.length){
      const sec=node('section','mz-ps-section');sec.append(node('div','mz-ps-title','Explore'));
      const links=node('div','mz-ps-links');
      collections.slice(0,4).forEach(c=>links.append(link(c.url||searchUrl,'mz-ps-link',c.title||'Collection')));
      queries.slice(0,4).forEach(q=>links.append(link(q.url||(`${searchUrl}?q=${encodeURIComponent(q.text||term)}`),'mz-ps-link',q.text||term)));
      sec.append(links);results.append(sec);
    }
    const all=link(`${searchUrl}?q=${encodeURIComponent(term)}`,'mz-ps-viewall');
    all.append(node('span','',`View all results for “${term}”`),node('span','','→'));results.append(all);
    openSearch();status&&(status.textContent=`${products.length+collections.length+queries.length} suggestions available`);
  }
  async function fetchResults(term){
    controller?.abort();controller=new AbortController();
    const url=new URL(endpoint+'.json',location.origin);
    url.searchParams.set('q',term);url.searchParams.set('resources[type]','product,collection,query');url.searchParams.set('resources[limit]',String(limit));
    url.searchParams.set('resources[limit_scope]','each');url.searchParams.set('resources[options][unavailable_products]','last');
    try{const res=await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal});if(!res.ok)throw new Error(String(res.status));render(await res.json(),term)}
    catch(e){if(e?.name!=='AbortError'){closeSearch();status&&(status.textContent='Search suggestions unavailable')}}
  }
  if(input&&predictive){
    input.addEventListener('input',()=>{clearTimeout(timer);const term=input.value.trim();if(term.length<min){closeSearch();return}timer=setTimeout(()=>fetchResults(term),180)});
    input.addEventListener('focus',()=>{const term=input.value.trim();if(term.length>=min&&!searchOpen)fetchResults(term)});
  }

  mobileSearch?.addEventListener('click',()=>{
    const next=header.dataset.mobileSearchOpen!=='true';header.dataset.mobileSearchOpen=next?'true':'false';mobileSearch.setAttribute('aria-expanded',String(next));
    if(next){closeMega();requestAnimationFrame(()=>input?.focus())}else closeSearch();
  });

  document.addEventListener('click',e=>{
    if(megaOpen&&!mega?.contains(e.target)&&!megaToggle?.contains(e.target))closeMega();
    if(searchOpen&&!searchWrap?.contains(e.target)&&!mobileSearch?.contains(e.target))closeSearch();
  });
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'){if(searchOpen){closeSearch();input?.focus()}else if(megaOpen)closeMega(true);if(header.dataset.mobileSearchOpen==='true'){header.dataset.mobileSearchOpen='false';mobileSearch?.setAttribute('aria-expanded','false')}}
  });
  addEventListener('resize',()=>{if(innerWidth<1024)closeMega()},{passive:true});

  if(motion){
    const magnets=header.querySelectorAll('.mz-premium-action,.mz-premium-nav__link');
    magnets.forEach(el=>{
      el.addEventListener('pointermove',e=>{if(matchMedia('(pointer:coarse)').matches)return;const r=el.getBoundingClientRect(),x=(e.clientX-r.left-r.width/2)*.08,y=(e.clientY-r.top-r.height/2)*.08;const g=gs();g?g.to(el,{x,y,duration:.22,ease:'power3.out',overwrite:true}):el.style.transform=`translate(${x}px,${y}px)`});
      el.addEventListener('pointerleave',()=>{const g=gs();g?g.to(el,{x:0,y:0,duration:.38,ease:'power3.out',overwrite:true}):el.style.removeProperty('transform')});
    });
  }
});
})();